import { styled } from 'leva/plugin';

export const StyledButton = styled('button', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  $reset: '',
  fontWeight: '$button',
  fontSize: '$root',
  width: 'auto',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: '10px 10px',
  height: '26px',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderRadius: '9999px',
  color: 'white',
  '&:not(:disabled)': {
    cursor: 'pointer',
  },
  variants: {
    active: {
      true: {
        backgroundColor: '$elevation3',
        borderColor: 'gray',
        color: '$highlight3',
      },
      false: {
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: '$highlight3',
      },
    },
  },
});
